import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { YoutubeVideoPreviewData } from '../../../../../../../models/google-template/preview-interfaces/youtube-video-preview-data.interface';
import { UrlDisplayHelper } from '../../../../../../../utils/url-display-helper';
import { VideoFormat, YoutubeFormatHelper } from '../../../../../../../utils/youtube-format-helper';
import { MobileFrameComponent } from '../../../preview-common/mobile-frame/mobile-frame.component';

/**
 * Skippable in-stream placement on the mobile watch page: the video runs in
 * the square player, and a compact row under it (logo, headline, sponsored
 * line, CTA pill) stands in for the end card. Grey skeleton blocks below the
 * row stand for the rest of the watch page. The 1:1 placement: a video in any
 * other format leaves the player empty.
 */
@Component({
    selector: 'app-youtube-video-in-stream-mobile',
    imports: [CommonModule, MobileFrameComponent],
    templateUrl: './youtube-in-stream-mobile.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./youtube-in-stream-mobile.component.scss']
})
export class YoutubeVideoInStreamMobilePreviewComponent {
  @Input() data!: YoutubeVideoPreviewData;

  /** The creative format this placement previews, found by measured ratio. */
  readonly format: VideoFormat = '1:1';

  private get videoId(): string {
    return this.data.video?.videoId ?? '';
  }

  /** Thumbnail of the video when it is 1:1, otherwise ''. */
  get thumbnailUrl(): string {
    return YoutubeFormatHelper.thumbnailForFormat([this.videoId], this.format);
  }

  /**
   * True while the link is still being measured, so the empty player says so
   * rather than asking for a video that is about to turn up.
   */
  get isResolving(): boolean {
    return YoutubeFormatHelper.isResolving(this.videoId);
  }

  /** The host, which is all the row shows of the destination. */
  get displayUrl(): string {
    return UrlDisplayHelper.hostOf(this.data.url);
  }

  get headline(): string {
    return this.data.headline || 'Your headline appears here';
  }
}
